"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
/**
 * Sets up event listeners for the provider and calls the handler function
 * when the provider has changed.
 *
 * @param handler Function to call when the provider has changed.
 */
function setProviderEventsHandler(handler) {
    let timeout;
    const timeoutDuration = 1000;
    // Called right before handler is called to block any more handler calls for 1 second.
    function blockListener() {
        timeout = setTimeout(() => {
            timeout = undefined;
        }, timeoutDuration);
    }
    function listener(change) {
        // Prioritize events where the user has connected or disconnected their wallet.
        if (change === 'address') {
            if (timeout) {
                clearTimeout(timeout);
                blockListener();
            }
            handler();
        }
        else {
            // If timeout already exists, do nothing.
            if (!timeout) {
                // Wait for timeoutDuration in case other simultanous events with more
                // pertinent data is about to be picked up.
                timeout = setTimeout(() => {
                    blockListener();
                    handler();
                }, timeoutDuration);
            }
        }
    }
    window.addEventListener(frontend_provider_types_1.ADDRESS_CHANGED, () => __awaiter(this, void 0, void 0, function* () {
        listener('address');
    }));
    window.addEventListener(frontend_provider_types_1.CHAIN_CHANGED, () => __awaiter(this, void 0, void 0, function* () {
        listener('chain');
    }));
    window.addEventListener(frontend_provider_types_1.PROVIDER_CHANGED, () => __awaiter(this, void 0, void 0, function* () {
        listener('provider');
    }));
}
exports.default = setProviderEventsHandler;
//# sourceMappingURL=providerEvents.js.map